(function () {
  'use strict';
  if (customElements.get('dallianse-shipping-progress')) return;

  function thresholdCents(usd, rate, currency) {
    if (!(usd > 0) || !(rate > 0)) return null;
    var digits = new Intl.NumberFormat('en', {style: 'currency', currency: currency}).resolvedOptions().maximumFractionDigits;
    var units = Math.pow(10, digits);
    return Math.round(Math.round(usd * rate * units) / units * 100);
  }

  class DeliveryTerms extends HTMLElement {
    connectedCallback() {
      var fee=Number(this.dataset.feeUsd), threshold=Number(this.dataset.thresholdUsd);
      var active=window.Shopify && window.Shopify.currency;
      var currency=active && active.active || 'USD';
      var rate=currency==='USD'?1:Number(active && active.rate);
      var fallback=this.dataset.shopCurrency!=='USD'||!(rate>0);
      if(fallback){currency='USD';rate=1;}
      try {
        var formatter=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:currency});
        var feeText=fallback?'USD '+fee.toFixed(2):formatter.format(fee*rate), thresholdText=fallback?'USD '+threshold.toFixed(2):formatter.format(threshold*rate);
        this.querySelector('[data-delivery-copy]').textContent=this.dataset.compact==='true'?
          'SHIPPING '+feeText+' · FREE '+thresholdText+'+':
          'Standard shipping: '+feeText+' below '+thresholdText+'. Free from '+thresholdText+' after discounts.';
      } catch(error) { /* Keep explicit USD fallback. */ }
    }
  }
  customElements.define('dallianse-delivery-terms',DeliveryTerms);

  class ShippingProgress extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.updateFromEvent = this.updateFromEvent.bind(this);
      this.readMarkup = this.readMarkup.bind(this);
      document.addEventListener('cart:updated', this.updateFromEvent);
      this.observer = new MutationObserver(this.readMarkup);
      if (this.form) {
        this.form.querySelectorAll('[data-products]').forEach(function (node) {
          this.observer.observe(node, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-cart-subtotal']});
        }, this);
      }
      this.readMarkup();
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.updateFromEvent);
      if (this.observer) this.observer.disconnect();
    }

    updateFromEvent(event) {
      var cart = event.detail && event.detail.cart;
      if (cart && Number.isFinite(Number(cart.total_price))) {
        this.dataset.total = String(cart.total_price);
        this.renderProgress(Number(cart.total_price));
      }
    }

    readMarkup() {
      var cart = this.form && this.form.querySelector('.cart__items[data-cart-subtotal]');
      if (cart) this.dataset.total = cart.dataset.cartSubtotal;
      this.renderProgress(Number(this.dataset.total));
    }

    renderProgress(total) {
      var active = window.Shopify && window.Shopify.currency;
      var currency = active && active.active || this.dataset.currency;
      var rate = currency === 'USD' ? 1 : Number(active && active.rate);
      // Shopify's presentment rate is relative to the shop currency. Never guess a USD conversion for a non-USD shop.
      if (this.dataset.shopCurrency !== 'USD' || !Number.isFinite(total) || total < 0) {
        this.hidden = true;
        return;
      }
      try {
        var threshold = thresholdCents(Number(this.dataset.thresholdUsd), rate, currency);
        if (!threshold) { this.hidden = true; return; }
        var remaining = Math.max(0, threshold - total);
        var percentage = Math.max(0, Math.min(100, Math.round(total / threshold * 100)));
        var money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: currency}).format(remaining / 100);
        this.querySelector('.dallianse-shipping-progress__message').textContent = remaining > 0 ? "You're only " + money + ' away from free shipping!' : "You've qualified for free shipping!";
        this.querySelector('.dallianse-shipping-progress__fill').style.width = percentage + '%';
        this.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', String(percentage));
        this.hidden = false;
      } catch (error) {
        this.hidden = true;
      }
    }
  }
  customElements.define('dallianse-shipping-progress', ShippingProgress);
})();
